module.exports = __webpack_public_path__ + "static/media/logo-네오위즈@3x.7aa2f003.png";